import * as Api from 'utils/api';

const basePath = 'order';

export function get() {
    const url = Api.buildUrl(basePath);
    return Api.getData(url);
}

export function getChangeLogs(lastCartItemChangeLogId, lastUserSessionChangeLogId) {
    const url = Api.buildUrl(`${basePath}/getchangelogs`, { lastCartItemChangeLogId, lastUserSessionChangeLogId });
    return Api.getData(url);
}

export function getJoinedUserCount(qrCodeId) {
    const url = Api.buildUrl(`${basePath}/getjoinedusercount`, { qrCodeId });
    return Api.getData(url);
}

export function leaveUserSession() {
    const url = Api.buildUrl(`${basePath}/leaveusersession`);
    return Api.postData(url);
}

export function startOrder(data) {
    const url = Api.buildUrl(`${basePath}/startOrder`);
    return Api.postData(url, data).then((response) => response.json());
}

export function addCartItem(data) {
    const url = Api.buildUrl(`${basePath}/addcartitem`);
    return Api.postData(url, data).then((response) => response.json());
}

export function updateCartItem(data) {
    const url = Api.buildUrl(`${basePath}/updatecartitem`);
    return Api.postData(url, data).then((response) => response.json());
}

export function updateCartItemQuantity(data) {
    const url = Api.buildUrl(`${basePath}/updatecartitemquantity`);
    return Api.postData(url, data).then((response) => response.json());
}

export function deleteCartItem(cartItemId) {
    const url = Api.buildUrl(`${basePath}/deletecartitem`, { cartItemId });
    return Api.deleteData(url);
}

export function confirmOrder(data) {
    const url = Api.buildUrl(`${basePath}/confirmorder`);
    return Api.postData(url, data).then((response) => response.json());
}

export function makePayment(data) {
    const url = Api.buildUrl(`${basePath}/makepayment`);
    return Api.postData(url, data).then((response) => response.json());
}
